import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { HeaderComponent } from "./header/header.component";
import {
  MatToolbarModule
} from '@angular/material/toolbar';
import {
  MatSidenavModule
} from '@angular/material/sidenav';
import { MatListModule
} from '@angular/material/list';
import { CookieService } from "ngx-cookie-service";

import { AppRoutingModule } from "../app.routing";
import { NgModule } from "@angular/core";
import { FooterComponent } from './footer/footer.component';
import { SupplierStateService } from '../../app/profile/services/supplierstate.service'
import { NavigationService } from '../profile/services/navigation.service'
import { LanguageService } from "./services/language.service";
import { NgSrmModule } from "@tesla/ng-srm";
import srmHeaderComponentConfig from "app/shared/config/srm-header-component.config";

@NgModule({
    imports: [
        CommonModule,
        SharedModule.forRoot(),
        AppRoutingModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        NgSrmModule.forRoot(srmHeaderComponentConfig),
    ],
    declarations: [HeaderComponent, FooterComponent],
    exports: [HeaderComponent, FooterComponent],
    providers: [CookieService, SupplierStateService, NavigationService, LanguageService],
})
export class CoreModule {}
